/**
 * @constant Maximum 32-bit signed integer value. (2^31 - 1)
 */

    module.exports = 2147483647;




//////////////////
// WEBPACK FOOTER
// ./~/mout/number/MAX_INT.js
// module id = 269
// module chunks = 0 1 2